module.exports = __webpack_public_path__ + "assets/balance-8253ac30.svg";